<template>
    <div id="app">
        <link
            href="https://fonts.googleapis.com/css?family=Roboto:,400,400i,500,500i,700,700i,900,900i&amp;subset=cyrillic,cyrillic-ext,greek,greek-ext,latin-ext,vietnamese&display=swap"
            rel="stylesheet"
        />
        <link
            href="https://fonts.googleapis.com/css?family=Work+Sans:300,400,500,600,700,800,900&display=swap"
            rel="stylesheet"
        />

        <router-view />
    </div>
</template>

<script>
export default {
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Welcome',
        // all titles will be injected into this template
        titleTemplate: `%s - ${process.env.VUE_APP_LUDUM_TITLE}`
    }
};
</script>

<style lang="scss">
@import './app.scss';
// Need to keep this here, don't ask why!
</style>
